<template>
    <div>
        <Spin
            v-if="innerSpin"
            size="large"
            fix
            style="margin-left: 200px"
        ></Spin>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                    <Input
                        v-model="searchKeyValue"
                        placeholder="请输入用户账号,姓名或者电话"
                        style="width: 200px"
                    ></Input>
                    <Button
                        type="primary"
                        style="margin-left: 5px"
                        @click="searchUserInfoByKeyValue"
                        >搜索</Button
                    >
                    <Select
                        v-if="isSearch"
                        v-model="productModel.realUserUuid"
                        placeholder="选择代下单客户"
                        style="width: 480px; margin-left: 5px"
                        @on-change="onChooseUser"
                    >
                        <Option
                            v-for="user in memberList"
                            :key="user.userUuid"
                            :style="
                                user.blackUserId
                                    ? { color: 'red' }
                                    : {}
                            "
                            :value="user.userUuid"
                            >{{
                                user.userPersonName +
                                " - " +
                                user.userName +
                                " - " +
                                user.userPhone +
                                "可用金额："
                            }}{{
                                getNumberThousandString(
                                    getNumberFloorDecimal(
                                        numberSubtraction(
                                            user.memberFundBalance,
                                            user.freezeMoney
                                        ),
                                        2
                                    ),
                                    "0.00"
                                )
                            }}<span v-if="user.blackUserId" style="color: red"
                                >（黑名单）</span
                            >
                        </Option>
                    </Select>
                    <Button
                        v-if="isSearch"
                        type="primary"
                        style="margin-left: 5px"
                        @click="openPreSaleOrder"
                        >新增定单</Button
                    >

                    <Button
                        v-if="isSearch"
                        type="primary"
                        style="margin-left: 5px"
                        @click="getPreSaleOrderTable"
                        >显示购物车订单</Button
                    >
                    <Button
                        v-if="isSearch"
                        type="primary"
                        style="margin-left: 5px"
                        @click="openMemberRecharger"
                        >充值</Button>
                    <Button
                        v-if="isSearch"
                        type="warning"
                        v-show="reviewsMainTable.data.length > 0"
                        style="margin-left: 5px"
                        @click="getReviewsTable"
                        >显示客户评价</Button
                    >
                    <Button
                        v-show="blackUser"
                        type="warning"
                        style="margin-left: 5px"
                        @click="showBlackUserList">黑名单用户</Button>
                </Col>
            </Row>
        </Card>
        <Modal title="客户评价" width="800" v-model="getReviewsShow">
            <Row :gutter="24">
                <stand-pagination-table
                    :columns="reviewsMainTable.columns"
                    :data="reviewsMainTable.data"
                    :extHeight="0"
                    :autoHeight="true"
                    :loading="reviewsMainTable.loading"
                    :table-search="reviewsMainTable.tableSearch"
                    :table-load-event="reviewsMainTableRecords"
                />
                <!-- <Table border :columns="reviewsMainTable.columns"   :loading="reviewsMainTable.loading" :data="reviewsMainTable.data"></Table> -->
            </Row>
            <div slot="footer"></div>
        </Modal>
        <Card
            style="position: relative; padding-bottom: 80px"
            v-show="preSaleOrderFlag"
        >
            <Row
                :gutter="16"
                v-for="(preSaleOrderMainVO, index) in preSaleOrderMainVOList"
                :key="index"
                style="
                    border: 1px solid #dddddd;
                    margin-top: 16px;
                    background-color: #f7f7f7;
                    padding: 10px;
                    border-radius: 3px;
                "
            >
                <Col span="24">
                    <Form label-position="top" class="form-input-no-outline">
                        <div class="global-tool-bar">
                            <div class="left-bar">
                                <Checkbox
                                    @on-change="changeItem(preSaleOrderMainVO)"
                                    :value="preSaleOrderMainVO.check"
                                    >选择定单
                                </Checkbox>
                            </div>
                            <div class="right-bar" style="margin-bottom: 20px">
                                <Button
                                    type="primary"
                                    @click="saveInfo(preSaleOrderMainVO)"
                                    >保存修改</Button
                                >
                            </div>
                        </div>
                        <Row :gutter="24">
                            <Col span="6">
                                <FormItem label="周次">
                                    <Input
                                        :value="preSaleOrderMainVO.weekSeq"
                                        disabled
                                    ></Input>
                                </FormItem>
                            </Col>
                            <Col span="6">
                                <FormItem label="发货日期">
                                    <Input
                                        :value="
                                            preSaleOrderMainVO.sendProductDate
                                        "
                                        disabled
                                    ></Input>
                                </FormItem>
                            </Col>
                            <Col span="6">
                                <FormItem label="客户名称">
                                    <Input
                                        :value="preSaleOrderMainVO.userName"
                                        disabled
                                    ></Input>
                                </FormItem>
                            </Col>
                            <Col span="6">
                                <FormItem label="联系方式">
                                    <Input
                                        v-model="
                                            preSaleOrderMainVO.contactNumber
                                        "
                                    ></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="24">
								<Col span="2">
								<FormItem label="省份" prop="memberDeliveryAddressProvinceUuid">
									<Select v-model="preSaleOrderMainVO.memberDeliveryAddressProvinceUuid" filterable clearable
										placeholder="请选择省" @on-change="(value) => onProvinceChange(value, index)" >
										<Option v-for="item in provinceOptions" :key="item.regionUuid"
											:value="item.regionUuid">{{ item.regionName }}</Option>
									</Select>
								</FormItem>
								</Col>
								<Col span="2">
								<FormItem label="城市" prop="memberDeliveryAddressCityUuid">
									<Select v-model="preSaleOrderMainVO.memberDeliveryAddressCityUuid" placeholder="请选择市"
										@on-change="(value) => onCityChange(value, index)" >
										<Option v-for="item in preSaleOrderMainVO.cityOptions" :key="item.regionUuid" :value="item.regionUuid">
											{{ item.regionName }}</Option>
									</Select>
								</FormItem>
								</Col>
								<Col span="2">
								<FormItem label="区/县" prop="memberDeliveryAddressDistUuid">
									<Select v-model="preSaleOrderMainVO.memberDeliveryAddressDistUuid" placeholder="请选择区/县" >
										<Option v-for="item in preSaleOrderMainVO.distOptions" :key="item.regionUuid" :value="item.regionUuid">
											{{ item.regionName }}</Option>
									</Select>
								</FormItem>
								</Col>
								<Col span="4">
								<FormItem label="收货地址">
									<Input v-model="preSaleOrderMainVO.receiptFullAddress" ></Input>
								</FormItem>
								</Col>
                                <Col span="2">
								<FormItem label="收货人">
									<Input v-model="preSaleOrderMainVO.memberDeliveryAddressContacts" ></Input>
								</FormItem>
								</Col>
                                <Col span="2">
                                <FormItem label=" ">
									<Button type="success" @click="changeAddress(index)">更换地址</Button>
								</FormItem>   
                                </Col>
								<Col span="10">
								<FormItem label="备注">
									<Input v-model="preSaleOrderMainVO.remark" type="textarea"></Input>
								</FormItem>
								</Col>
						</Row>
                        <Row :gutter="24">
                            <!-- <Col span="12">
                                <FormItem label="收货地址">
                                    <Input
                                        v-model="
                                            preSaleOrderMainVO.receiptFullAddress
                                        "
                                    ></Input>
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="备注">
                                    <Input
                                        v-model="preSaleOrderMainVO.remark"
                                        type="textarea"
                                    ></Input>
                                </FormItem>
                            </Col> -->
                            <Col span="6">
                                <FormItem label="配送费(元)">
                                    <InputNumber
                                        v-model="
                                            preSaleOrderMainVO.farmDeliveryFee
                                        "
                                        :min="0"
                                        :active-change="false"
                                        style="
                                            width: 100%;
                                            text-align: left !important;
                                        "
                                    ></InputNumber>
                                </FormItem>
                            </Col>
                            <Col span="6">
                                <FormItem :label="`包装费(元)`">
                                    <InputNumber
                                        v-model="
                                            preSaleOrderMainVO.farmPackageFee
                                        "
                                        :min="0"
                                        :active-change="false"
                                        style="
                                            width: 100%;
                                            text-align: left !important;
                                        "
                                    ></InputNumber>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="24">
                            <!-- <Col span="6">
						<FormItem label="其它优惠方案">
							<Select :value="preSaleOrderMainVO.preSaleOrderRecordArtiDiscProgramme" @on-change="updateArtiDiscProgramme($event,preSaleOrderMainVO,index)">
								<Option v-for="item in discountProgrammeList" :value="item.value" :key="item.value" >{{
									item.label }}</Option>
							</Select>
						</FormItem>
						</Col> -->
                            <Col span="6">
                                <FormItem label="其它优惠(元)">
                                    <InputNumber
                                        :value="
                                            preSaleOrderMainVO.preSaleOrderRecordArtiDiscUnitDisAmount
                                        "
                                        :precision="4"
                                        :ref="'refArtiDiscUnitAmount' + index"
                                        :min="0"
                                        :max="
                                            getOrderMainVoArtificialDiscountUniyMax(
                                                preSaleOrderMainVO
                                            )
                                        "
                                        :step="0.0001"
                                        @on-change="
                                            changeArtiDiscUnitDisAmount(
                                                $event,
                                                preSaleOrderMainVO
                                            )
                                        "
                                        :active-change="false"
                                        :formatter="
                                            (value) =>
                                                parseFloat(value.toString())
                                        "
                                        style="
                                            width: 100%;
                                            text-align: left !important;
                                        "
                                    ></InputNumber>
                                </FormItem>
                                <!-- <FormItem v-if="preSaleOrderMainVO.preSaleOrderRecordArtiDiscProgramme==2" label="总价优惠金额(元)">
							<InputNumber :value="preSaleOrderMainVO.preSaleOrderRecordArtiDiscTotalAmount" :ref="'refArtiDiscTotalAmount'+index" @on-change="changeArtiDiscTotalAmount(preSaleOrderMainVO,$event)" :min="0"  :active-change="false"  :max="preSaleOrderMainVO.mainTotalMoney"  :step="0.01"
								style="width:100%;text-align: center !important;"></InputNumber>
						</FormItem> -->
                            </Col>
                            <!-- <Col span="6">
						<FormItem  label="优惠总金额(元)">
							<Input v-model="preSaleOrderMainVO.preSaleOrderRecordArtiDiscTotalAmount" disabled :min="0"   :step="0.01" :active-change="false"
								style="width:100%;text-align: left !important;"></Input>
						</FormItem>
						</Col> -->
                        </Row>
                        <Row :gutter="16" style="margin-top: 10px">
                            <Col span="24">
                                <Table
                                    ref="mainTable"
                                    size="small"
                                    :columns="preSaleTable.tableColumns"
                                    :data="preSaleOrderMainVO.orderItmeList"
                                    stripe
                                    border
                                />
                            </Col>
                        </Row>
                        <div
                            style="
                                width: 100%;
                                text-align: right;
                                padding-top: 10px;
                            "
                        >
                            <div>
                                小计: &nbsp;&nbsp; 数量:<span
                                    class="red-color"
                                    >{{
                                        getNumberThousandString(
                                            preSaleOrderMainVO.mainOrderQuantity,
                                            "0",
                                            0
                                        )
                                    }}</span
                                >
                                &nbsp;&nbsp;金额:<span class="red-color"
                                    >{{
                                        getNumberThousandString(
                                            preSaleOrderMainVO.mainTotalMoney,
                                            "0.00"
                                        )
                                    }}元
                                </span>
                                &nbsp;&nbsp;优惠总额:<span class="red-color"
                                    >{{
                                        getNumberThousandString(
                                            preSaleOrderMainVO.preSaleOrderRecordProductDiscount,
                                            "0.00"
                                        )
                                    }}元</span
                                >
                                &nbsp;&nbsp;需付定金:<span class="red-color"
                                    >{{
                                        getNumberThousandString(
                                            preSaleOrderMainVO.mainTotalDepositMoney,
                                            "0.00"
                                        )
                                    }}元</span
                                >
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Card>
        <Card
            style="position: absolute; right: 4%; bottom: 0; width: 82%"
            v-show="preSaleOrderFlag"
        >
            <Row
                :gutter="16"
                style="
                    border: 1px solid #dddddd;
                    background-color: #f7f7f7;
                    border-radius: 3px;
                "
            >
                <Col span="24">
                    <Form label-position="top" class="form-input-no-outline">
                        <div class="global-tool-bar">
                            <div class="left-bar">
                                <Checkbox
                                    @on-change="selectAll"
                                    :value="allChecked"
                                    >全选</Checkbox
                                >

                                <div>
                                    合计: &nbsp;&nbsp; 数量:<span
                                        class="red-color"
                                        >{{
                                            getNumberThousandString(
                                                totalMainCount,
                                                0,
                                                0
                                            )
                                        }}</span
                                    >
                                    &nbsp;&nbsp;金额:<span class="red-color"
                                        >{{
                                            getNumberThousandString(
                                                totalMainMoney,
                                                "0.00"
                                            )
                                        }}元</span
                                    >
                                    &nbsp;&nbsp;需付定金:<span class="red-color"
                                        >{{
                                            getNumberThousandString(
                                                totalMainDepositMoney,
                                                "0.00"
                                            )
                                        }}元</span
                                    >
                                </div>
                            </div>
                            <div class="right-bar">
                                <span style="color: #ff9900">
                                    提示:配送费、包装费、其它优惠方案提交前点击保存修改才有效
                                </span>
                            </div>
                            <div class="right-bar">
                                <Button
                                    type="success"
                                    style="
                                        background-color: #d40909;
                                        border-color: #d40909;
                                    "
                                    @click="addToPreSaleOrder()"
                                    >提交定单</Button
                                >
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Card>
        <Card v-show="preSaleOrderNoDataFlag">
            <Row :gutter="16" style="margin-top: 10px; text-align: center">
                <Col span="24">
                    <span class="title">当前购物车没有订单!</span>
                </Col>
            </Row>
        </Card>
        <Card v-show="depositPaidOrderFlag">
            <Row :gutter="16" style="margin-top: 10px">
                <Col span="24">
                    <Table
                        ref="mainTable"
                        size="small"
                        :columns="depositBillList.tableColumns"
                        :data="depositBillList.depositBillMainVOList"
                        stripe
                        border
                    />
                </Col>
            </Row>
        </Card>
        <saleHelpPutCartDetail ref="saleHelpPutCartDetailModal" />
        <depositOrderDetail ref="depositOrderDetailModal" />
        <addPreSaleOrderRecord ref="addPreSaleOrderRecord" />
        <BlackUserListModal ref="blackUserListModal"/>
        <selectDeliveryAddress ref="selectDeliveryAddress" @handlesSelectedDeliveryAddress="hanldeSelectedAddress"/>
        <payModalDetail ref="PayModal" @refresh-data="init"/>
    </div>
</template>

<script>
import {
    dateRender,
    dateTimeRender,
    getNumberThousandString,
    getNumberFloorDecimal,
    getNumberDecimalFixed,
    numberSubtraction,
    numberDecimalMul,
    numberDecimalMulArr,
    numberDecimalDIV,
    numberDecimalAdd,
    numberDecimalAddArrary,
    numberDecimalSub
} from "@/libs/tableRowTimeRender";
import { getDefaultSeedFarmUuid } from "@/api/modules/system-management/user-management.js";
import {
    getCustomerManagerRelateCustomerUser,
    webGetMemberDeliveryAddressByUserId,
    getAllProductList,
    submitPreSaleCart,
    closePreSaleOrder,
    savePreSaleOrderInfo,
    webGetPreSaleProductList,
    webSubmitToOrder,
    submitDepositBillRecord,
    getPreSaleOrderList,
    getProductPromotionList,
    getCustomerPromotionList,
    getDepositBillListByDepositPaidList
} from "@/api/modules/sale-management/sale-approve";
import { getUserReviewsList } from "@/api/modules/account-management/externalCustomer-user-management";
import { getContract } from '@/api/modules/preSale-management/deposit-order.js';
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { productQuantityIsRoundedMixin } from "@/view/mixins/ProductQuantityIsRounded.js";
import search from "@/libs/search";
import { arrayUnique } from "@/libs/logic";
import { FILE_SERVER } from "@/api/modules/files";
import saleHelpPutCartDetail from "./sale-help-put-cart-detail";
import depositOrderDetail from "./deposit-order-detail";
import DecimalInput from "@/components/number-input/decimal-input";
import addPreSaleOrderRecord from "./add-PreSale-Order-Record";
import IntegerInput from "@/components/number-input/integer-input";
import BlackUserListModal from '@/view/seedFarm-management/seedFarm-member-black-list/seedFarm-member-black-list-modal.vue';
import {
    numberToFixed,
    number2ThousandsFormat
} from "@/components/number-input/display-format";
import { forEach } from "@/libs/tools";
import { webGetAllRegion } from '@/api/modules/system-management/region-management';
import selectDeliveryAddress from "./select-delivery-address";
import payModalDetail from './pay';

export default {
    name: "SaleHelpPutCart",
    components: {
        StandPaginationTable,
        saleHelpPutCartDetail,
        depositOrderDetail,
        addPreSaleOrderRecord,
        DecimalInput,
        IntegerInput,
        BlackUserListModal,
        selectDeliveryAddress,
        payModalDetail
    },
    mixins: [productQuantityIsRoundedMixin],
    data() {
        return {
            isClick: false,
            searchKeyValue: "",
            isSearch: false,
            preSaleOrderBtn: false,
            depositPaidOrderBtn: true,
            preSaleOrderMainVOList: [],
            preSaleOrderMainVOListOriginal: [],
            sumbitDetailUuids: [],
            sendProductDateArray: [],
            totalMainCount: 0,
            totalMainMoney: 0,
            totalMainDepositMoney: 0,
            allChecked: false,
            preSaleOrderFlag: false,
            preSaleOrderNoDataFlag: false,
            depositPaidOrderFlag: false,
            addressId: "",
            innerSpin: false,
            showTip: false,
            productModel: {
                realUserUuid: "",
                productUuid: "",
                selectedWeek: 1,
                selectDay: "",
                productPreSaleWarehouseAmount: null,
                productIncreaseStepAmount: 1,
                productMinOrderAmount: 1
            },
            productList: [],
            filterModel: {
                yearList: [],
                weekList: [],
                dayList: [],
                curWeekPlans: [],
                loadWeekPlans: false,
                selectedYearWeekList: [],
                selectedYearPlans: [],
                selectedYearFilterPlans: [],
                monthList: [],
                selectedMonth: 0,
                selectedMonthShow: false,
                selectedMonthText: "",
                loadYearPlans: false,
                selectedYear: 0,
                selectedWeeks: [],
                tabList: [
                    {
                        name: "本周"
                    },
                    {
                        name: "按周"
                    },
                    {
                        name: "按年"
                    }
                ],
                swiperCurrent: 0
            },
            memberList: [],
            chooseUserUuid: "",
            chooseProductUuid: "",
            productCodeQuery: {
                preSale: ""
            },
            preSaleTable: {
                tableColumns: [
                    {
                        title: "序号",
                        align: "center",
                        width: "50",
                        render: (h, params) => {
                            if (params.row.brandName != "合计") {
                                return h("span", params.row._index + 1);
                            }
                        }
                    },
                    {
                        title: "产品信息",
                        key: "productCodeAndName",
                        width: 100,
                        align: "center"
                    },
                    {
                        title: "苗场",
                        key: "seedFarmName",
                        width: 100,
                        align: "center"
                    },
                    { title: "产品形态", key: "productForm", align: "center" },
                    { title: "品牌", key: "brandName", align: "center" },
                    {
                        title: "可售量",
                        key: "preSalePlanOfferAmount",
                        align: "center"
                    },
                    {
                        title: "单位",
                        key: "unitName",
                        width: 80,
                        align: "center"
                    },
                    {
                        title: "单价",
                        key: "preSalePlanPrice",
                        width: 80,
                        align: "center"
                    },
                    {
                        title: "数量",
                        align: "center",
                        key: "orderQuantity",
                        render: (h, params) => {
                            if (params.row.productCodeAndName) {
                                return h("InputNumber", {
                                    props: {
                                        value: params.row.orderQuantity,
                                        min: 1,
                                        max:
                                            params.row.preSalePlanOfferAmount
                                            + this.GetOriginalAmount(params.row),
                                        activeChange: false,
                                        step: params.row
                                            .productIncreaseStepAmount,
                                        precision: this.getUnitisRounded(params.row.unitName)
                                    },
                                    style: {
                                        textAlign: "center"
                                    },
                                    on: {
                                        "on-change": event => {
                                            //  event= this.updateRowOrderQuantity(params.row,event);
                                            params.row.orderQuantity = event;
                                            this.updateRow(
                                                params.row,
                                                "orderQuantity"
                                            );
                                            this.SetRowTotalAmount(params.row);
                                            //this.SetRowProductDiscount(params.row);
                                            this.SetTotalAmount(params.row);
                                            this.checkQuantity(
                                                params.index,
                                                params.row
                                            );
                                            // this.setArtiDisAmountByOrderQuantity(params.row,event);
                                        }
                                    }
                                });
                            }
                            else {
                                return h("span", params.row.orderQuantity);
                            }
                        }
                    },
                    { title: "金额", key: "totalMoney", align: "center" },

                    {
                        title: "商品优惠",
                        key: "preSaleOrderDetailProductUnitPrice",
                        align: "center"
                    },
                    {
                        title: "客户优惠",
                        key: "preSaleOrderDetailCustomerUnitPrice",
                        align: "center"
                    },
                    // { title: '商品优惠(总价)', key: 'preSaleOrderDetailProductDiscount', align: 'center' },
                    // { title: '客户优惠(总价)', key: 'preSaleOrderDetailCustomerDiscount', align: 'center' },
                    // {
                    // 	title: '其它优惠(总价)', key: 'preSaleOrderDetailArtificialDiscountAmount', align: 'center',

                    // 	render: (h, params) => {
                    // 		if(params.row.brandName!='合计'){
                    // 			return h(DecimalInput, {
                    // 				props: {
                    // 					value: params.row.preSaleOrderDetailArtificialDiscountAmount,
                    // 					min: 0,
                    // 					max: this.getArtificialDiscountAmountMax(params.row),
                    // 					disabled: this.isNoDiscount(params.row.uuid),
                    // 					step: 0.01
                    // 				},
                    // 				style: {
                    // 					textAlign: "center"
                    // 				},
                    // 				on: {
                    // 					'change': event => {
                    // 						params.row.preSaleOrderDetailArtificialDiscountAmount = event;
                    // 						this.updateRow(params.row, 'preSaleOrderDetailArtificialDiscountAmount')
                    // 						this.getArtiDiscTotalAmount(params.row);
                    // 					}
                    // 				}
                    // 			});
                    // 		}
                    //         else{
                    // 			return h('span',params.row.preSaleOrderDetailArtificialDiscountAmount)
                    // 		}
                    // 	}
                    // },
                    {
                        title: "其它优惠",
                        key: "preSaleOrderDetailArtificialUnitAmount",
                        align: "center",
                        render: (h, params) => {
                            if (params.row.brandName != "合计") {
                                return h("InputNumber", {
                                    props: {
                                        value: params.row
                                            .preSaleOrderDetailArtificialUnitAmount,
                                        min: 0,
                                        max: this.getArtificialDiscountUnitMax(
                                            params.row
                                        ),
                                        //	disabled: this.isNoDiscount(params.row.uuid),
                                        activeChange: false,
                                        formatter: value =>
                                            parseFloat(value.toString()),
                                        step: 0.0001,
                                        precision: 4
                                    },
                                    style: {
                                        textAlign: "center"
                                    },
                                    on: {
                                        "on-change": event => {
                                            if (!event) {
                                                event = 0;
                                            }
                                            params.row.preSaleOrderDetailArtificialUnitAmount
                                                = event;
                                            this.updateRow(
                                                params.row,
                                                "preSaleOrderDetailArtificialUnitAmount"
                                            );
                                            this.SetRowDiscountAmount(
                                                params.row,
                                                event
                                            );
                                        }
                                    }
                                });
                            }
                        }
                    },
                    // { title: '累计优惠', key: 'preSaleOrderDetailDiscountTotal', align: 'center' },
                    {
                        title: "结算单价",
                        key: "preSaleOrderDetailDiscountTotal",
                        align: "center",
                        render: (h, params) => {
                            if (params.row.brandName != "合计") {
                                let discountAmount = this.getSettleAmount(
                                    params.row
                                );
                                return h("span", discountAmount);
                            }
                        }
                    },
                    {
                        title: "结算金额",
                        key: "discountAmount",
                        align: "center",
                        render: (h, params) => {
                            let discountAmount = this.getDiscountAmount(
                                params.row
                            );
                            return h("span", discountAmount);
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 80,
                        render: (h, params) => {
                            if (params.row.brandName != "合计") {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small",
                                                shape: "circle"
                                            },
                                            on: {
                                                click: () => {
                                                    this.cancelSelectFn(
                                                        params.row.uuid
                                                    );
                                                }
                                            }
                                        },
                                        "删除"
                                    )
                                ]);
                            }
                        }
                    }
                ],
                loading: false
            },
            depositBillList: {
                tableColumns: [
                    {
                        key: "billCode",
                        title: "定金单编号"
                    },
                    {
                        key: "seedFarmName",
                        title: "苗场名称"
                    },
                    {
                        key: "weekSeq",
                        title: "周次"
                    },
                    {
                        key: "sendProductDate",
                        title: "发货日期"
                    },
                    {
                        key: "receiptFullAddress",
                        title: "收货地址"
                    },
                    {
                        key: "depositBillRecordDepositPaymentSum",
                        title: "已付定金"
                    },
                    {
                        key: "surplus",
                        title: "待付余额",
                        render: (h, params) => {
                            let surplus = (
                                params.row.totalFee
                                - params.row.depositBillRecordDepositPaymentSum
                            ).toFixed(2);
                            return h("span", parseFloat(surplus));
                        }
                    },
                    {
                        key: "totalFee",
                        title: "定单总额"
                    },
                    {
                        key: "paidStatus",
                        title: "定单状态"
                    },
                    {
                        key: "depositBillRecordCreateAt",
                        title: "定单时间",
                        render: (h, params) =>
                            dateTimeRender(
                                h,
                                params.row.depositBillRecordCreateAt
                            )
                    },
                    {
                        key: "operatorName",
                        title: "经办人"
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 160,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            color: "green"
                                        },
                                        on: {
                                            click: () => {
                                                this.showPayModel(
                                                    params.row
                                                        .depositBillRecordUuid
                                                );
                                            }
                                        }
                                    },
                                    "支付余额"
                                )
                            ]);
                        }
                    }
                ],
                keyword: "",
                depositBillMainVOList: [],
                isTableBusy: false,
                feSearch: search.getSearchParams(),
                loading: false
            },
            getReviewsShow: false,
            reviewsMainTable: {
                columns: [
                    {
                        title: "行号",
                        type: "index",
                        width: 80,
                        align: "center"
                    },
                    {
                        title: "被评价人",
                        key: "userPersonName",
                        width: 80,
                        align: "center"
                    },
                    { title: "评价", key: "userReviewsText", align: "center" },
                    {
                        title: "评价人",
                        key: "evaluatorPersonName",
                        width: 80,
                        align: "center",
                        render: (h, params) => {
                            let evaluatorPersonName = "";
                            if (
                                this.personType == "S"
                                || this.personUserID
                                    == params.row.userReviewsEvaluatorUuid
                            ) {
                                evaluatorPersonName
                                    = params.row.evaluatorPersonName;
                            }

                            return h("div", evaluatorPersonName);
                        }
                    },
                    {
                        title: "创建时间",
                        key: "userReviewsCreateAt",
                        width: 120,
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.userReviewsCreateAt)
                    }
                ],
                data: [],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            blackUser: false,
            discountProgrammeList: [
                {
                    value: 0,
                    label: "无其它优惠"
                },
                {
                    value: 1,
                    label: "有其它优惠"
                }
                // {
                // 	value: 2,
                // 	label: '总价优惠'
                // }
            ],
            productPromotionList: [],
            customerPromotionList: [],
            allRegions: [],
            provinceOptions: [],
            defaultSeedFarmUuid: {}       
        };
    },
    mounted() {
        let now = new Date();
        this.filterModel.selectedYear = now.getFullYear();
        this.filterModel.yearList = [now.getFullYear()];
        this.getRegionList();
        this.getDefaultSeedFarmUuid();
    },
    computed: {
        personUserID() {
            return this.$store.state.user.userId;
        }
    },
    watch: {
        "productModel.realUserUuid": {
            handler(newVal, oldVal) {
                this.reviewsMainTableRecords();
            }
        }
    },
    methods: {
        getNumberThousandString,
        getNumberFloorDecimal,
        numberSubtraction,
        moveUp(index, row) {
            if (index === 0) return;
            // Find the list containing this row
            let preSaleOrderMainVO = this.preSaleOrderMainVOList.find(
                mainVO =>
                    mainVO.orderItmeList.some(item => item.uuid == row.uuid)
            );
            if (!preSaleOrderMainVO) return;
            
            let list = preSaleOrderMainVO.orderItmeList;
            // Swap
            let temp = list[index - 1];
            this.$set(list, index - 1, list[index]);
            this.$set(list, index, temp);
            
            // Update sort order
            this.updateSortOrder(list);
        },
        moveDown(index, row) {
            // Find the list containing this row
            let preSaleOrderMainVO = this.preSaleOrderMainVOList.find(
                mainVO =>
                    mainVO.orderItmeList.some(item => item.uuid == row.uuid)
            );
            if (!preSaleOrderMainVO) return;
            
            let list = preSaleOrderMainVO.orderItmeList;
            
            if (index >= list.length - 2) return;

            // Swap
            let temp = list[index + 1];
            this.$set(list, index + 1, list[index]);
            this.$set(list, index, temp);
            
            // Update sort order
            this.updateSortOrder(list);
        },
        updateSortOrder(list) {
            list.forEach((item, index) => {
                if (item.brandName != "合计") {
                    item.preSaleOrderDetailSort = index;
                }
            });
        },
        getAllUserList(keyValueStr) {
            this.innerSpin = true;
            getCustomerManagerRelateCustomerUser({
                keyValue: keyValueStr
            }).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.memberList = res.data;
                    localStorage.setItem(
                        "memberListObj",
                        JSON.stringify(this.memberList)
                    );
                    this.blackUserShow(this.productModel.realUserUuid);
                    if (this.memberList.length < 1) {
                        this.$Modal.info({
                            title: "提示",
                            content: "未查询到该客户，请检查是否输入正确。"
                        });
                    }
                    else {
                        let ishasreal = this.memberList
                            .map(item => item.userUuid)
                            .includes(this.productModel.realUserUuid);
                        if (!ishasreal) {
                            this.productModel.realUserUuid = "";
                        }
                    }
                }
            });
        },
        getDefaultSeedFarmUuid(){
            getDefaultSeedFarmUuid({}).then(res => {
                if (res.code === 0) {
                    this.defaultSeedFarmUuid = res.data.defaultSeedFarmUuid;
                }
            });
        },
        isNoDiscount(uuid) {
            let preSaleOrderMainVO = this.preSaleOrderMainVOList.find(
                mainVO =>
                    mainVO.orderItmeList.some(item => item.uuid == uuid)
            );
            return preSaleOrderMainVO.preSaleOrderRecordArtiDiscProgramme == 0;
        },
        searchUserInfoByKeyValue() {
            if (!this.searchKeyValue) {
                this.$Modal.info({
                    title: "提示",
                    content: "请输入用户账号或者姓名！"
                });
                return;
            }
            this.productModel.realUserUuid = "";
            this.isSearch = true;
            let keyValue = this.searchKeyValue;
            localStorage.setItem("searchKeyValue", this.searchKeyValue);
            this.getAllUserList(keyValue);
        },
        showPayModel(depositBillRecordUuid) {
            this.$refs.depositOrderDetailModal.showModal(
                "",
                this.productModel.realUserUuid,
                depositBillRecordUuid
            );
        },
        changeArtiDiscTotalAmount(preSaleOrderMainVO, e) {
            preSaleOrderMainVO.preSaleOrderRecordArtiDiscTotalAmount = e;
            this.changeArtiDiscTotalAmountOrderList(preSaleOrderMainVO, e);
        },
        updateArtiDiscProgramme(event, preSaleOrderMainVO, index) {
            preSaleOrderMainVO.preSaleOrderRecordArtiDiscProgramme = event;
            if (event == 0) {
                //重现选择无优惠单价优惠和总价优惠都设置未0
                preSaleOrderMainVO.preSaleOrderRecordArtiDiscUnitDisAmount = 0;
                this.changeArtiDiscUnitDisAmount(0, preSaleOrderMainVO);
            }
            if (event == 1) {
                //this.changeArtiDiscUnitDisAmount(index,preSaleOrderMainVO);
                this.SetArtiDiscUnitDisAmountTable(
                    preSaleOrderMainVO,
                    preSaleOrderMainVO.preSaleOrderRecordArtiDiscUnitDisAmount
                );
            }
            // if(event==2){
            // 	preSaleOrderMainVO.preSaleOrderRecordArtiDiscUnitDisAmount=0;
            // }
        },
        changeArtiDiscTotalAmountOrderList(preSaleOrderMainVO, totalDisAmount) {
            let orderItmeList = preSaleOrderMainVO.orderItmeList;
            if (orderItmeList.length == 1) {
                orderItmeList[0].preSaleOrderDetailArtificialDiscountAmount
                    = totalDisAmount;
            }
            else {
                let sumTotalMoney = orderItmeList.reduce(
                    (a, b) => a + b.totalMoney,
                    0
                );
                if (sumTotalMoney > 0) {
                    let sumtotalDisAmount = 0;
                    for (let i = 0; i < orderItmeList.length - 1; i++) {
                        let disAmout = getNumberDecimalFixed(
                            (orderItmeList[i].totalMoney / sumTotalMoney)
                                * totalDisAmount
                        );
                        disAmout = Number(disAmout);
                        orderItmeList[
                            i
                        ].preSaleOrderDetailArtificialDiscountAmount = disAmout;
                        sumtotalDisAmount += disAmout;
                    }
                    orderItmeList[
                        orderItmeList.length - 1
                    ].preSaleOrderDetailArtificialDiscountAmount
                        = numberSubtraction(totalDisAmount, sumtotalDisAmount);
                }
            }
        },
        getArtiDiscTotalAmount(row) {
            // let preSaleOrderMainVO=this.preSaleOrderMainVOList.find(mainVO =>mainVO.orderItmeList.some(item=>item.uuid==row.uuid));
            // let preSaleOrderRecordArtiDiscTotalAmount= preSaleOrderMainVO.orderItmeList.reduce((a, b) => a + b.preSaleOrderDetailArtificialDiscountAmount, 0);
            // preSaleOrderMainVO.preSaleOrderRecordArtiDiscTotalAmount=preSaleOrderRecordArtiDiscTotalAmount;

            let list = [];
            this.preSaleOrderMainVOList.forEach(mainVO => {
                list = [...list, ...mainVO.orderItmeList];
            });
            let orderItem = list.find(item => item.uuid == row.uuid);
            // this.setDiscountAmount(orderItem,event);
            orderItem.preSaleOrderDetailArtificialUnitAmount = numberDecimalDIV(
                orderItem.preSaleOrderDetailArtificialDiscountAmount,
                orderItem.orderQuantity,
                4
            );
            this.setDiscountTotal(orderItem);
            let preSaleOrderMainVO = this.preSaleOrderMainVOList.find(
                mainVO =>
                    mainVO.orderItmeList.some(item => item.uuid == row.uuid)
            );
            this.setTotalRow(preSaleOrderMainVO);
        },
        getDiscountAmount(row) {
            // let preSaleOrderMainVO=this.preSaleOrderMainVOList.find(mainVO =>mainVO.orderItmeList.some(item=>item.uuid==row.uuid));
            // if(preSaleOrderMainVO.preSaleOrderRecordArtiDiscProgramme==0){
            return numberDecimalSub(
                row.totalMoney,
                row.preSaleOrderDetailDiscountTotal
            );
            // }
            // // else{
            // // 	return numberDecimalSub(row.totalMoney,row.preSaleOrderDetailDiscountTotal);
            // // }
        },
        getSettleAmount(row) {
            //优惠总单价格
            let totalUnitPrice = numberDecimalAddArrary(
                [
                    row.preSaleOrderDetailProductUnitPrice,
                    row.preSaleOrderDetailCustomerUnitPrice,
                    row.preSaleOrderDetailArtificialUnitAmount
                ],
                4
            );
            return numberDecimalSub(row.preSalePlanPrice, totalUnitPrice, 4);
        },
        //计算总金额
        SetTotalAmount(row) {
            let preSaleOrderMainVO = this.preSaleOrderMainVOList.find(
                mainVO =>
                    mainVO.orderItmeList.some(item => item.uuid == row.uuid)
            );
            let orderItmeList = preSaleOrderMainVO.orderItmeList.filter(
                item => item.brandName != "合计"
            );
            let totalMoney = orderItmeList.reduce(
                (a, b) => a + b.totalMoney,
                0
            );
            let totalQuantity = orderItmeList.reduce(
                (a, b) => a + b.orderQuantity,
                0
            );
            preSaleOrderMainVO.mainOrderQuantity = totalQuantity;
            preSaleOrderMainVO.mainTotalMoney = totalMoney;
            preSaleOrderMainVO.mainTotalDepositMoney = orderItmeList.reduce(
                (a, b) =>
                    a
                    + numberDecimalMulArr([
                        b.totalMoney,
                        b.preSaleOrderDetailProductDepositRatio,
                        0.01
                    ]),
                0
            );
            //numberDecimalMul(preSaleOrderMainVO.DepositDueProp,preSaleOrderMainVO.mainTotalMoney);

            //计算商品优惠
            this.SetRowProductDiscount(row);
            //计算客户优惠
            this.SetRowCustomerDiscount(preSaleOrderMainVO);

            for (let i = 0; i < orderItmeList.length; i++) {
                //计算其它优惠
                this.setDiscountAmount(
                    orderItmeList[i],
                    orderItmeList[i].preSaleOrderDetailArtificialUnitAmount
                );
                //计算累计优惠
                this.setDiscountTotal(orderItmeList[i]);
            }
            //汇总合计
            this.setTotalRow(preSaleOrderMainVO);
        },
        //修改数量后重现计算优惠
        setArtiDisAmountByOrderQuantity(row, event) {
            let preSaleOrderMainVO = this.preSaleOrderMainVOList.find(
                mainVO =>
                    mainVO.orderItmeList.some(item => item.uuid == row.uuid)
            );
            if (preSaleOrderMainVO.preSaleOrderRecordArtiDiscProgramme == 0) {
                //无手工优惠
                return;
            }
            else if (
                preSaleOrderMainVO.preSaleOrderRecordArtiDiscProgramme == 1
            ) {
                //单价优惠重现计算优惠金额
                this.SetArtiDiscUnitDisAmountTable(
                    preSaleOrderMainVO,
                    preSaleOrderMainVO.preSaleOrderRecordArtiDiscUnitDisAmount
                );
                return;
            }
            // else {
            //     //总价优惠时重现计算各子项的优惠
            // 	let artiDiscTotalAmount=preSaleOrderMainVO.preSaleOrderRecordArtiDiscTotalAmount<=preSaleOrderMainVO.mainTotalMoney?preSaleOrderMainVO.preSaleOrderRecordArtiDiscTotalAmount:preSaleOrderMainVO.mainTotalMoney;
            // 	this.changeArtiDiscTotalAmount(preSaleOrderMainVO,artiDiscTotalAmount);
            // 	return;
            // }
        },
        SetRowTotalAmount(row) {
            let list = [];
            this.preSaleOrderMainVOList.forEach(mainVO => {
                list = [...list, ...mainVO.orderItmeList];
            });
            let orderItem = list.find(item => item.uuid == row.uuid);
            orderItem.totalMoney = numberDecimalMul(
                orderItem.orderQuantity,
                orderItem.preSalePlanPrice
            );
        },
        SetRowProductDiscount(row) {
            let list = [];
            this.preSaleOrderMainVOList.forEach(mainVO => {
                list = [...list, ...mainVO.orderItmeList];
            });
            let orderItem = list.find(item => item.uuid == row.uuid);
            let productPro = this.productPromotionList.find(
                item => item.productUuid == orderItem.productUuid
            );
            if (productPro == null || productPro.productPromotion == null) {
                return;
            }

            let unitPriceDiscount = 0;

            //达到指定订购量，可优惠  orderQuantity
            if (
                orderItem.orderQuantity
                >= productPro.productPromotion.promotionQuantityThreshold
            ) {
                unitPriceDiscount
                    = productPro.productPromotion.promotionQuantityDisount;
            }
            //达到指定订购额，可优惠
            if (
                orderItem.totalMoney
                >= productPro.productPromotion.promotionValueThreshold
            ) {
                unitPriceDiscount = numberDecimalAdd(
                    unitPriceDiscount,
                    productPro.productPromotion.promotionValudeDiscount
                );
            }
            //达到指定付定金比例，可优惠
            if (
                orderItem.preSaleOrderDetailProductDepositRatio
                >= productPro.productPromotion.promotionDepositThreshold
            ) {
                //定金优惠
                unitPriceDiscount = numberDecimalAdd(
                    unitPriceDiscount,
                    productPro.productPromotion.promotionDepositDiscount
                );
            }

            orderItem.preSaleOrderDetailProductDiscount = numberDecimalMul(
                orderItem.orderQuantity,
                unitPriceDiscount
            );
            orderItem.preSaleOrderDetailProductUnit = unitPriceDiscount;
            //	orderItem.totalMoney=numberDecimalMul(orderItem.orderQuantity,orderItem.preSalePlanPrice);
        },
        //设置客户优惠
        SetRowCustomerDiscount(preSaleOrderMainVO) {
            // let list=[];
            // this.preSaleOrderMainVOList.forEach(mainVO =>{list=[...list,...mainVO.orderItmeList]});
            let orderItmeList = preSaleOrderMainVO.orderItmeList.filter(
                item => item.brandName != "合计"
            );
            let customerPro = this.customerPromotionList.find(
                item => item.seedFarmUuid == orderItmeList[0].seedFarmUuid
            );
            if (customerPro == null || customerPro.customerPromotion == null) {
                return;
            }

            let customerPromotion = customerPro.customerPromotion;

            for (let orderItme of orderItmeList) {
                debugger;
                //客户优惠总额
                let customerDiscount = 0;
                //客户优惠单价
                let preSaleOrderDetailCustomerUnitPrice = 0;

                if (customerPromotion.promotionQuantityDisount > 0) {
                    customerDiscount = numberDecimalMul(
                        numberDecimalSub(
                            1,
                            customerPromotion.promotionQuantityDisount
                        ),
                        orderItme.totalMoney
                    );
                    preSaleOrderDetailCustomerUnitPrice = numberDecimalMul(
                        numberDecimalSub(
                            1,
                            customerPromotion.promotionQuantityDisount
                        ),
                        orderItme.preSalePlanPrice,
                        4
                    );
                }
                //单价优惠,单位元,减1分=0.01、5分=0.05
                if (customerPromotion.promotionValudeDiscount > 0) {
                    customerDiscount = numberDecimalAdd(
                        customerDiscount,
                        numberDecimalMul(
                            customerPromotion.promotionValudeDiscount,
                            orderItme.orderQuantity
                        )
                    );
                    preSaleOrderDetailCustomerUnitPrice = numberDecimalAdd(
                        preSaleOrderDetailCustomerUnitPrice,
                        customerPromotion.promotionValudeDiscount
                    );
                }
                //总价优惠,单位元,减100=100、减500=500、减1000=1000
                if (customerPromotion.promotionDepositDiscount > 0) {
                    //(优惠*子单产品金额)/主单总金额/子单数量
                    let depositDiscountTotalMoney = numberDecimalDIV(
                        numberDecimalMul(
                            customerPromotion.promotionDepositDiscount,
                            orderItme.totalMoney
                        ),
                        preSaleOrderMainVO.mainTotalMoney
                    );
                    let depositDiscount = numberDecimalDIV(
                        depositDiscountTotalMoney,
                        orderItme.preSaleOrderDetailOrderQuantity,
                        4
                    );

                    customerDiscount = numberDecimalAdd(
                        customerDiscount,
                        depositDiscountTotalMoney
                    );
                    preSaleOrderDetailCustomerUnitPrice = numberDecimalAdd(
                        preSaleOrderDetailCustomerUnitPrice,
                        depositDiscount
                    );
                }
                orderItme.preSaleOrderDetailCustomerUnitPrice
                    = preSaleOrderDetailCustomerUnitPrice;
                orderItme.preSaleOrderDetailCustomerDiscount = customerDiscount;
            }
        },
        //计算每一列的其它优惠的最大金额
        getArtificialDiscountAmountMax(row) {
            //金额-商品优惠-客户优惠
            return numberDecimalSub(
                row.totalMoney,
                numberDecimalAdd(
                    row.preSaleOrderDetailProductDiscount,
                    row.preSaleOrderDetailCustomerDiscount
                )
            );
        },
        //计算每一列的其它优惠的最大单价
        getArtificialDiscountUnitMax(row) {
            return numberDecimalDIV(
                this.getArtificialDiscountAmountMax(row),
                row.orderQuantity,
                4
            );
        },
        //计算每一列的其它优惠的最大金额
        getOrderMainVoArtificialDiscountUniyMax(preSaleOrderMainVO) {
            let orderItmeList = preSaleOrderMainVO.orderItmeList.filter(
                item => item.brandName != "合计"
            );
            let arr = [];
            orderItmeList.forEach(row => {
                arr.push(this.getArtificialDiscountUnitMax(row));
            });
            return Math.min(...arr);
        },
        changeArtiDiscUnitDisAmount(event, preSaleOrderMainVO) {
            if (!event) {
                event = 0;
            }

            preSaleOrderMainVO.preSaleOrderRecordArtiDiscUnitDisAmount = event;
            // let orderItmeList= preSaleOrderMainVO.orderItmeList;
            // let totalDiscountAmount=0;
            // for(let i=0;i<orderItmeList.length;i++){
            // 	let discountAmount=Number(event)*orderItmeList[i].orderQuantity;
            // 	orderItmeList[i].preSaleOrderDetailArtificialDiscountAmount=discountAmount;
            // 	totalDiscountAmount+=discountAmount;
            // }
            // preSaleOrderMainVO.preSaleOrderRecordArtiDiscTotalAmount=totalDiscountAmount;
            //this.SetArtiDiscUnitDisAmountTable(preSaleOrderMainVO,event);
            let orderItmeList = preSaleOrderMainVO.orderItmeList.filter(
                item => item.brandName != "合计"
            );
            for (let orderItme of orderItmeList) {
                orderItme.preSaleOrderDetailArtificialUnitAmount = event;
                this.setDiscountAmount(orderItme, event);
                this.setDiscountTotal(orderItme);
            }
            this.setTotalRow(preSaleOrderMainVO);
        },
        //计算每一列累计优惠
        setDiscountTotal(orderItme) {
            orderItme.preSaleOrderDetailDiscountTotal = numberDecimalAddArrary([
                orderItme.preSaleOrderDetailCustomerDiscount,
                orderItme.preSaleOrderDetailProductDiscount,
                orderItme.preSaleOrderDetailArtificialDiscountAmount
            ]);
        },
        //通过其它优惠单价计算每一列的其它优惠金额
        setDiscountAmount(orderItme, event) {
            let discountAmount = numberDecimalMul(
                Number(event),
                orderItme.orderQuantity
            );
            orderItme.preSaleOrderDetailArtificialDiscountAmount
                = discountAmount;
        },
        SetRowDiscountAmount(row, event) {
            let list = [];
            this.preSaleOrderMainVOList.forEach(mainVO => {
                list = [...list, ...mainVO.orderItmeList];
            });
            let orderItem = list.find(item => item.uuid == row.uuid);
            this.setDiscountAmount(orderItem, event);
            this.setDiscountTotal(orderItem);
            let preSaleOrderMainVO = this.preSaleOrderMainVOList.find(
                mainVO =>
                    mainVO.orderItmeList.some(item => item.uuid == row.uuid)
            );
            this.setTotalRow(preSaleOrderMainVO);
        },
        SetArtiDiscUnitDisAmountTable(preSaleOrderMainVO, event) {
            let orderItmeList = preSaleOrderMainVO.orderItmeList;
            let totalDiscountAmount = 0;
            for (let i = 0; i < orderItmeList.length; i++) {
                this.setDiscountAmount(orderItmeList[i], event);
                this.setDiscountTotal(orderItmeList[i]);

                totalDiscountAmount = numberDecimalAdd(
                    totalDiscountAmount,
                    orderItmeList[i].preSaleOrderDetailArtificialDiscountAmount
                );
            }

            preSaleOrderMainVO.preSaleOrderRecordArtiDiscTotalAmount
                = totalDiscountAmount;
        },
        reviewsMainTableRecords() {
            let userUuid = this.productModel.realUserUuid;
            if (userUuid) {
                getUserReviewsList({ userUuid }).then(res => {
                    if (res.code == 0) {
                        this.reviewsMainTable.data = res.data.list;
                    }
                });
                this.blackUserShow(userUuid);
            }
            else {
                this.reviewsMainTable.data = [];
            }
        },
        replaceStr(dateStr) {
            if (dateStr != null && dateStr != "") {
                return dateStr
                    .replace("年", "-")
                    .replace("月", "-")
                    .replace("日", "")
                    .replace(/星期./, "");
            }
            return "";
        },
        //单选
        changeItem(preSaleOrderMainVO) {
            preSaleOrderMainVO.check = !preSaleOrderMainVO.check;
            if (!preSaleOrderMainVO.check) {
                let sendProductDateArray = this.sendProductDateArray;
                let dateIndex = sendProductDateArray.indexOf(
                    this.replaceStr(preSaleOrderMainVO.sendProductDate)
                );
                if (dateIndex > -1) {
                    sendProductDateArray.splice(dateIndex, 1);
                    this.totalMainCount -= preSaleOrderMainVO.mainOrderQuantity;
                    this.totalMainMoney -= preSaleOrderMainVO.mainTotalMoney;
                    this.totalMainDepositMoney
                        -= preSaleOrderMainVO.mainTotalDepositMoney;
                }
                this.sendProductDateArray = sendProductDateArray;
            }
            else {
                let sendProductDateArray = this.sendProductDateArray;
                let dateIndex = sendProductDateArray.indexOf(
                    this.replaceStr(preSaleOrderMainVO.sendProductDate)
                );
                if (dateIndex == -1) {
                    this.sendProductDateArray.push(
                        this.replaceStr(preSaleOrderMainVO.sendProductDate)
                    );
                    this.totalMainCount += preSaleOrderMainVO.mainOrderQuantity;
                    this.totalMainMoney += preSaleOrderMainVO.mainTotalMoney;
                    this.totalMainDepositMoney
                        += preSaleOrderMainVO.mainTotalDepositMoney;
                }
            }
        },
        //全选，全不选
        selectAll() {
            this.allChecked = !this.allChecked;
            if (this.allChecked) {
                this.sendProductDateArray = [];
                // eslint-disable-next-line array-callback-return
                this.preSaleOrderMainVOList.map(preSaleOrderMainVO => {
                    this.sendProductDateArray.push(
                        this.replaceStr(preSaleOrderMainVO.sendProductDate)
                    );
                    preSaleOrderMainVO.check = true;
                });
                let tCount = 0,
                    tMoney = 0.0,
                    tDepositMoney = 0.0;
                this.preSaleOrderMainVOList.forEach(item => {
                    tCount += item.mainOrderQuantity;
                    tMoney += item.mainTotalMoney;
                    tDepositMoney += Number(item.mainTotalDepositMoney);
                });
                this.totalMainCount = tCount;
                this.totalMainMoney = tMoney;
                this.totalMainDepositMoney = tDepositMoney;
            }
            else {
                this.sendProductDateArray = [];
                this.preSaleOrderMainVOList.map(preSaleOrderMainVO => {
                    preSaleOrderMainVO.check = false;
                });
                this.totalMainCount = 0;
                this.totalMainMoney = 0;
                this.totalMainDepositMoney = 0;
            }
        },
        updateRow(row, cloumnName) {
            // eslint-disable-next-line array-callback-return
            this.preSaleOrderMainVOList.map(mainVO => {
                // eslint-disable-next-line array-callback-return
                mainVO.orderItmeList.map(item => {
                    if (row.uuid == item.uuid) {
                        item[cloumnName] = row[cloumnName];
                    }
                });
            });
        },
        GetOriginalAmount(row) {
            if (!this.sumbitDetailUuids.includes(row.uuid)) {
                return 0;
            }
            let list = [];
            this.preSaleOrderMainVOListOriginal.forEach(mainVO => {
                list = [...list, ...mainVO.orderItmeList];
            });
            let orderItem = list.find(item => item.uuid == row.uuid);
            return orderItem.orderQuantity;
        },
        // updateRowOrderQuantity(row,event){
        // 	debugger
        // 	if(row.preSalePlanOfferAmount<event){
        //        event=row.preSalePlanOfferAmount;
        // 	   this.$Message.warning({
        //             background: true,
        //             content: '数量不能超过可售量'
        //         });
        // 		event=	row.preSalePlanOfferAmount;
        // 	}
        // 	return event;
        // 	// }
        // 	// this.preSaleOrderMainVOList.map(mainVO =>{
        // 	// 	mainVO.orderItmeList.map(item =>{
        // 	// 		if(row.uuid==item.uuid){
        // 	// 			item[cloumnName]=row[cloumnName];
        // 	// 		}
        // 	// 	});
        // 	// });

        // },
        saveInfo(preSaleOrderMainVO) {
            if (preSaleOrderMainVO.contactNumber == "") {
                this.$Modal.info({
                    title: "提示",
                    content: "非常抱歉，联系方式不能为空！"
                });
                return;
            }
            if (preSaleOrderMainVO.receiptFullAddress == "" 
                || preSaleOrderMainVO.memberDeliveryAddressProvinceUuid == "" 
                || preSaleOrderMainVO.memberDeliveryAddressCityUuid == ""
                || preSaleOrderMainVO.memberDeliveryAddressDistUuid == ""
                || preSaleOrderMainVO.memberDeliveryAddressContacts == "") {
                this.$Modal.info({
                    title: "提示",
                    content: "非常抱歉，收货地址与收货人信息不能为空！"
                });
                return;
            }

            let flag = false;
            let flagZero = false;

            preSaleOrderMainVO.orderItmeList
                = preSaleOrderMainVO.orderItmeList.filter(
                    item => item.brandName != "合计"
                );
            preSaleOrderMainVO.orderItmeList.forEach(item => {
                if (item.productCodeAndName) {
                    if (item.orderQuantity > item.preSalePlanOfferAmount) {
                        flag = true;
                    }
                    if (item.orderQuantity <= 0) {
                        flagZero = true;
                    }
                }
            });
            // if(flag){
            // 	this.$Modal.info({ title: '提示', content: '非常抱歉，订购数量不能大于可售量！' });
            // 	return;
            // }
            if (flagZero) {
                this.$Modal.info({
                    title: "提示",
                    content: "非常抱歉，订购数量不能小于等于0！"
                });
                return;
            }

            let data = {
                preSaleOrderMainVO: preSaleOrderMainVO,
                userUuid: this.productModel.realUserUuid
            };
            this.preSaleTable.loading = true;
            savePreSaleOrderInfo(data).then(res => {
                this.preSaleTable.loading = false;
                if (res.code === 0) {
                    this.addressId = res.data.memberDeliveryAddressUuid;
                    this.$Message.success("保存修改成功！");
                    this.getUserOrderInfo();
                }
            });
        },
        cancelSelectFn(detailUuid) {
            this.preSaleTable.loading = true;
            closePreSaleOrder({
                uuid: detailUuid
            }).then(res => {
                this.preSaleTable.loading = false;
                if (res.code === 0) {
                    this.getUserOrderInfo();
                    this.$Message.success("删除成功！");
                }
            });
        },
        openPreSaleOrder() {
            if (
                this.productModel.realUserUuid == ""
                || this.productModel.realUserUuid == undefined
            ) {
                this.$Modal.error({
                    title: "出错啦",
                    content: "非常抱歉，代下单客户不能为空！"
                });
                return;
            }
            this.$refs.addPreSaleOrderRecord.showModal(this.productModel.realUserUuid, this.defaultSeedFarmUuid);
        },
        openMemberRecharger() {
            if (
                this.productModel.realUserUuid == "" ||
                this.productModel.realUserUuid == undefined
            ) {
                this.$Modal.error({
                    title: "出错啦",
                    content: "非常抱歉，代下单客户不能为空！",
                });
                return;
            }
            this.$refs.PayModal.showModal(this.productModel.realUserUuid);
        },
        getPreSaleOrderTable() {
            if (
                this.productModel.realUserUuid == ""
                || this.productModel.realUserUuid == undefined
            ) {
                this.$Modal.error({
                    title: "出错啦",
                    content: "非常抱歉，代下单客户不能为空！"
                });
                return;
            }
            this.preSaleOrderBtn = false;
            this.depositPaidOrderBtn = true;
            this.depositPaidOrderFlag = false;
            this.getUserOrderInfo();
        },
        getDepositPaidOrderTable() {
            if (
                this.productModel.realUserUuid == ""
                || this.productModel.realUserUuid == undefined
            ) {
                this.$Modal.error({
                    title: "出错啦",
                    content: "非常抱歉，代下单客户不能为空！"
                });
                return;
            }
            this.preSaleOrderBtn = true;
            this.depositPaidOrderBtn = false;
            this.preSaleOrderFlag = false;
            this.preSaleOrderNoDataFlag = false;
            this.getDepositPaidOrderList();
        },
        getReviewsTable() {
            this.getReviewsShow = true;
            this.reviewsMainTableRecords();
        },
        getDepositPaidOrderList() {
            this.depositPaidOrderFlag = true;
            //参考管理后台的购物车列表，然后查看，系查看明细
            this.depositBillList.loading = true;
            getDepositBillListByDepositPaidList({
                userUuid: this.productModel.realUserUuid,
                paidStatus: "定金已支付"
            }).then(res => {
                this.depositBillList.loading = false;
                if (res.code === 0) {
                    this.depositBillList.depositBillMainVOList
                        = res.data.depositBillMainVOList.filter(
                            row =>
                                row.totalFee
                                    - row.depositBillRecordDepositPaymentSum
                                > 0
                        );
                }
            });
        },
        addToPreSaleOrder() {
            if (this.isClick) {
                return;
            }
            if (this.sendProductDateArray.length == 0) {
                this.$Modal.info({
                    title: "提示",
                    content: "非常抱歉，需要至少勾选一个订单！"
                });
                return;
            }
            if (this.addressId == "" || this.addressId == undefined) {
                this.$Modal.info({
                    title: "提示",
                    content: "非常抱歉，请填写保存收货地址！"
                });
                return;
            }
            if (
                this.productModel.realUserUuid == ""
                || this.productModel.realUserUuid == undefined
            ) {
                this.$Modal.info({
                    title: "提示",
                    content: "非常抱歉，代下单客户不能为空！"
                });
                return;
            }
            this.isClick = true;
            let data = {
                sendProductDateArray: this.sendProductDateArray,
                addressId: this.addressId,
                userUuid: this.productModel.realUserUuid
            };
            this.innerSpin = true;
            submitDepositBillRecord(data).then(res => {
                this.isClick = false;
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Message.success("提交订单成功！");
                    this.getUserOrderInfo();
                    let sendProductDate = encodeURIComponent(
                        JSON.stringify(this.sendProductDateArray)
                    );
                    this.$refs.depositOrderDetailModal.showModal(
                        sendProductDate,
                        this.productModel.realUserUuid,
                        ""
                    );
                    this.sendProductDateArray = [];
                }
            });
        },
        numberToFixed,
        init() {
            let searchKeyValueStr = localStorage.getItem("searchKeyValue");
            if (searchKeyValueStr) {
                this.searchKeyValue = searchKeyValueStr;
                this.getAllUserList(this.searchKeyValue);
            }
            this.memberList = [];
            let memberListObj = localStorage.getItem("memberListObj");
            if (memberListObj) {
                this.isSearch = true;
                this.memberList = JSON.parse(memberListObj);
            }
            let realUserUuidStr = localStorage.getItem("realUserUuid");
            if (realUserUuidStr) {
                this.productModel.realUserUuid = realUserUuidStr;
                this.getUserOrderInfo();
                //this.getDefaultAddress();
                //this.getUserOrderInfo();
            }
    
        },
        updateOrderAmount(event) {
            let curAmount = this.productModel.productPreSaleWarehouseAmount;
            let stepAmount = this.productModel.productIncreaseStepAmount;
            let result = Math.ceil(curAmount / stepAmount);
            let amount = result * stepAmount;
            this.productModel.productPreSaleWarehouseAmount = amount;
        },
        onChooseUser(row) {
            if (this.productModel.realUserUuid) {
                localStorage.setItem(
                    "realUserUuid",
                    this.productModel.realUserUuid
                );
                this.blackUserShow(this.productModel.realUserUuid);
                this.getUserOrderInfo();
                //this.getDefaultAddress();
            }
            else {
                this.blackUserShow(row);
            }
        },
        blackUserShow(row) {
            const member = this.memberList.find(
                item => item.userUuid == row
            );
            console.log("memberList", this.memberList);
            if (member.blackUserId) {
                this.blackUser = true;
            }
            else {
                this.blackUser = false;
            }
        },
        showBlackUserList(){
            this.$refs.blackUserListModal.showModal(localStorage.getItem("realUserUuid"), false);
        },
        
        getDefaultAddress() {
            webGetMemberDeliveryAddressByUserId({
                userUuid: this.productModel.realUserUuid
            }).then(res => {
                if (res.code === 0) {
                    if (res.data.addresses != null) {
                        this.addressId
                            = res.data.addresses.memberDeliveryAddressUuid;
                    }
                }
            });
        },
        //计算各列的客户优惠,计算合计列之前调用
        setPreSaleOrderMainVOListItemCustomerDiscount() {
            for (let preSaleOrde of this.preSaleOrderMainVOList) {
                for (let i = 0; i < preSaleOrde.orderItmeList.length; i++) {
                    let orderItme = preSaleOrde.orderItmeList[i];
                    orderItme.preSaleOrderDetailCustomerDiscount
                        = numberDecimalMul(
                            orderItme.orderQuantity,
                            orderItme.preSaleOrderDetailCustomerUnitPrice
                        );
                    this.setDiscountTotal(orderItme);
                }
            }
        },
        setTotalRow(preSaleOrde) {
            let orderItmeList = preSaleOrde.orderItmeList.filter(
                item => item.brandName != "合计"
            );
            let preSaleOrderDetailCustomerDiscount = numberDecimalAddArrary(
                orderItmeList.map(
                    item => item.preSaleOrderDetailCustomerDiscount
                )
            );
            let preSaleOrderDetailProductDiscount = numberDecimalAddArrary(
                orderItmeList.map(
                    item => item.preSaleOrderDetailProductDiscount
                )
            );
            let preSaleOrderDetailArtificialDiscountAmount
                = numberDecimalAddArrary(
                    orderItmeList.map(
                        item =>
                            item.preSaleOrderDetailArtificialDiscountAmount
                    )
                );
            let preSaleOrderDetailDiscountTotal = numberDecimalAddArrary(
                orderItmeList.map(
                    item => item.preSaleOrderDetailDiscountTotal
                )
            );
            let orderQuantity = numberDecimalAddArrary(
                orderItmeList.map(item => item.orderQuantity)
            );
            let totalMoney = numberDecimalAddArrary(
                orderItmeList.map(item => item.totalMoney)
            );
            let discountAmount = numberDecimalAddArrary(
                orderItmeList.map(item => item.discountAmount)
            );
            let totalItem = preSaleOrde.orderItmeList.find(
                item => item.brandName == "合计"
            );
            totalItem.preSaleOrderDetailCustomerDiscount
                = preSaleOrderDetailCustomerDiscount;
            totalItem.preSaleOrderDetailProductDiscount
                = preSaleOrderDetailProductDiscount;
            totalItem.preSaleOrderDetailArtificialDiscountAmount
                = preSaleOrderDetailArtificialDiscountAmount;
            totalItem.preSaleOrderDetailDiscountTotal
                = preSaleOrderDetailDiscountTotal;
            totalItem.orderQuantity = orderQuantity;
            totalItem.totalMoney = totalMoney;
            totalItem.discountAmount = discountAmount;
            preSaleOrde.preSaleOrderRecordProductDiscount
                = preSaleOrderDetailDiscountTotal;
        },
        // //计算定金比例
        // setDepositDueProp(){
        // 	for(let  preSaleOrde of this.preSaleOrderMainVOList){
        // 		if(preSaleOrde.mainTotalMoney<=0){
        // 			preSaleOrde.DepositDueProp=0.02;
        // 		}
        // 		else{
        // 			preSaleOrde.DepositDueProp=numberDecimalDIV(preSaleOrde.mainTotalDepositMoney,preSaleOrde.mainTotalMoney,4);
        // 		}
        // 	}
        // },
        insertTotalRow() {
            for (let preSaleOrde of this.preSaleOrderMainVOList) {
                // let preSaleOrderDetailCustomerDiscount=numberDecimalAddArrary(preSaleOrde.orderItmeList.filter(item=>item.brandName!='品牌').map(item=>item.preSaleOrderDetailCustomerDiscount));
                // let preSaleOrderDetailProductDiscount=numberDecimalAddArrary(preSaleOrde.orderItmeList.map(item=>item.preSaleOrderDetailProductDiscount));
                // let preSaleOrderDetailArtificialDiscountAmount=numberDecimalAddArrary(preSaleOrde.orderItmeList.map(item=>item.preSaleOrderDetailArtificialDiscountAmount));
                // let preSaleOrderDetailDiscountTotal=numberDecimalAddArrary(preSaleOrde.orderItmeList.map(item=>item.preSaleOrderDetailDiscountTotal));
                // let orderQuantity=numberDecimalAddArrary(preSaleOrde.orderItmeList.map(item=>item.orderQuantity),0);
                // let totalMoney=numberDecimalAddArrary(preSaleOrde.orderItmeList.map(item=>item.totalMoney));
                // let discountAmount=numberDecimalAddArrary(preSaleOrde.orderItmeList.map(item=>item.discountAmount));
                let orderItemTotal = {
                    preSaleOrderDetailCustomerDiscount: 0,
                    preSaleOrderDetailProductDiscount: 0,
                    preSaleOrderDetailArtificialDiscountAmount: 0,
                    preSaleOrderDetailDiscountTotal: 0,
                    orderQuantity: 0,
                    totalMoney: 0,
                    discountAmount: 0,
                    brandName: "合计"
                };
                preSaleOrde.orderItmeList.push(orderItemTotal);
                this.setTotalRow(preSaleOrde);
            }
        },
        //获取产品优惠
        getProductPromotionList(preSaleOrderMainVOList) {
            let list = [];
            preSaleOrderMainVOList.forEach(mainVO => {
                list = [...list, ...mainVO.orderItmeList];
            });
            let productUuids = list.map(item => item.productUuid);
            //去重
            productUuids = [...new Set(productUuids)];
            getProductPromotionList({ productUuids }).then(res => {
                if (res.code == 0) {
                    this.productPromotionList = res.data;
                }
            });
        },
        //获取客户优惠
        getCustomerPromotionList(preSaleOrderMainVOList) {
            let list = [];
            preSaleOrderMainVOList.forEach(mainVO => {
                list = [...list, ...mainVO.orderItmeList];
            });
            let seedFarmUuids = list.map(item => item.seedFarmUuid);
            //去重s
            seedFarmUuids = [...new Set(seedFarmUuids)];
            getCustomerPromotionList({
                userUuid: this.productModel.realUserUuid,
                seedFarmUuids
            }).then(res => {
                if (res.code == 0) {
                    this.customerPromotionList = res.data;
                }
            });
        },
        getUserOrderInfo() {
            //参考管理后台的购物车列表，然后查看，系查看明细
            this.preSaleTable.loading = true;
            getPreSaleOrderList({
                userUuid: this.productModel.realUserUuid
            }).then(res => {
                this.preSaleTable.loading = false;
                if (res.code === 0) {
                    this.preSaleOrderMainVOList
                        = res.data.preSaleOrderMainVOList;
                    this.sumbitDetailUuids = res.data.sumbitDetailUuids;
                    this.preSaleOrderMainVOListOriginal = JSON.parse(
                        JSON.stringify(this.preSaleOrderMainVOList)
                    );

                    if (res.data.preSaleOrderMainVOList.length > 0) {
                        this.getProductPromotionList(
                            res.data.preSaleOrderMainVOList
                        );
                        this.getCustomerPromotionList(
                            res.data.preSaleOrderMainVOList
                        );
                    }

                    // this.setDepositDueProp();
                    this.setPreSaleOrderMainVOListItemCustomerDiscount();
                    this.insertTotalRow();
                    if (this.preSaleOrderMainVOList.length > 0) {
                        this.preSaleOrderFlag = true;
                        this.preSaleOrderNoDataFlag = false;
                    }
                    else {
                        this.preSaleOrderFlag = false;
                        this.preSaleOrderNoDataFlag = true;
                    }
                    this.totalMainCount = 0;
                    this.totalMainMoney = 0;
                    this.totalMainDepositMoney = 0;
                    for(var item in this.preSaleOrderMainVOList){
                        this.preSaleOrderMainVOList[item].cityOptions = this.allRegions.filter(r => r.regionType === 2 && r.regionParentUuid === this.preSaleOrderMainVOList[item].memberDeliveryAddressProvinceUuid);
					    this.preSaleOrderMainVOList[item].distOptions = this.allRegions.filter(r => r.regionType === 3 && r.regionParentUuid === this.preSaleOrderMainVOList[item].memberDeliveryAddressCityUuid);
                        this.addressId= this.preSaleOrderMainVOList[item].preSaleOrderRecordDeliveryAddressUuid;
                    }
  
                }
            });
        },
        checkQuantity(index, row) {
            const { orderQuantity, preSalePlanOfferAmount } = row;
            if (orderQuantity > preSalePlanOfferAmount) {
                this.preSaleTable[index].orderQuantity = preSalePlanOfferAmount;
                this.$Message.error({
                    content: `数量不能大于可售量`,
                    duration: 5
                });
            }
        },
        getRegionList(){
            webGetAllRegion().then(res => {
                if (res.code === 0) {
                    this.allRegions = res.data.allRegions;
                    this.provinceOptions = this.allRegions.filter(r => r.regionType === 1);
                }
                this.init();
            });
        },
        onProvinceChange(provinceUuid, index) {
            this.preSaleOrderMainVOList[index].memberDeliveryAddressCityUuid='';
            this.preSaleOrderMainVOList[index].memberDeliveryAddressDistUuid='';
            this.preSaleOrderMainVOList[index].cityOptions = this.allRegions.filter(r => r.regionType === 2 && r.regionParentUuid === provinceUuid);
            this.preSaleOrderMainVOList[index].distOptions=[];
        },
        onCityChange(cityUuid, index) {
            this.preSaleOrderMainVOList[index].distOptions = this.allRegions.filter(r => r.regionType === 3 && r.regionParentUuid === cityUuid);
        },
        changeAddress(index){
            this.$refs.selectDeliveryAddress.showModal(index);
        },
        hanldeSelectedAddress(value, index){
            this.preSaleOrderMainVOList[index].memberDeliveryAddressProvinceUuid=value.memberDeliveryAddressProvinceUuid;
            this.onProvinceChange(value.memberDeliveryAddressProvinceUuid, index);
            this.preSaleOrderMainVOList[index].memberDeliveryAddressCityUuid=value.memberDeliveryAddressCityUuid;
            this.onCityChange(value.memberDeliveryAddressCityUuid, index);
            this.preSaleOrderMainVOList[index].memberDeliveryAddressDistUuid=value.memberDeliveryAddressDistUuid;
            this.preSaleOrderMainVOList[index].receiptFullAddress=value.memberDeliveryAddressFull;
            this.addressId = value.memberDeliveryAddressUuid;
        }
    }
};
</script>

<style scoped>
.red-color {
    color: red;
    font-weight: bold;
}
</style>
